export default {
    // apiUrl: 'http://localhost:8000',
    // imgPath: '',
    adminDomain: 'http://localhost:8080',
    apiUrl: 'https://api.d4dramadresses.in/',
    imgPath: 'https://api.d4dramadresses.in/',
    // adminDomain: 'http://66.29.131.44:9090',
    stripeClientId: 'ca_Hn4W7AZE81NvVyRF2s3hz8dksvbsw39l',
    perPageData: 25,
    DateFormat: 'YYYY-MM-DD',
    FullDateFormat: 'YYYY-MM-DD LTS',
    currencyCode: '₹'
}